import { useState } from "react";

export const useStateUpdate = (cb: () => void, deps: unknown[]) => {
  const [prev, setPrev] = useState<unknown[]>([]);

  if (deps.length !== prev.length || deps.some((x, i) => prev[i] !== x)) {
    setPrev(deps);
    cb();
  }
};
